// --- Selectors ---

// ✅ Add Document
export const selectAddSupportedDocumentData = (state) => state?.supportedDocuments?.addSupportedDocument?.data;
export const selectAddSupportedDocumentLoading = (state) => state?.supportedDocuments?.addSupportedDocument?.loading;
export const selectAddSupportedDocumentError = (state) => state?.supportedDocuments?.addSupportedDocument?.error;

// ✅ Update Document
export const selectUpdateSupportedDocumentData = (state) => state?.supportedDocuments?.updateSupportedDocument?.data;
export const selectUpdateSupportedDocumentLoading = (state) => state?.supportedDocuments?.updateSupportedDocument?.loading;
export const selectUpdateSupportedDocumentError = (state) => state?.supportedDocuments?.updateSupportedDocument?.error;

// ✅ Document List
export const selectSupportedDocumentsList = (state) => state?.supportedDocuments?.getSupportedDocumentsList?.data || [];
export const selectSupportedDocumentsListLoading = (state) => state?.supportedDocuments?.getSupportedDocumentsList?.loading;
export const selectSupportedDocumentsListError = (state) => state?.supportedDocuments?.getSupportedDocumentsList?.error;
export const selectSupportedDocumentsListTotal = (state) => state?.supportedDocuments?.getSupportedDocumentsList?.total || 0;

// ✅ Single Document
export const selectSupportedDocumentById = (state) => state?.supportedDocuments?.getSupportedDocumentById?.data;
export const selectSupportedDocumentByIdLoading = (state) => state?.supportedDocuments?.getSupportedDocumentById?.loading;
export const selectSupportedDocumentByIdError = (state) => state?.supportedDocuments?.getSupportedDocumentById?.error;

// ✅ Archive Document
export const selectArchiveSupportedDocumentData = (state) => state?.supportedDocuments?.archiveSupportedDocument?.data;
export const selectArchiveSupportedDocumentLoading = (state) => state?.supportedDocuments?.archiveSupportedDocument?.loading;
export const selectArchiveSupportedDocumentError = (state) => state?.supportedDocuments?.archiveSupportedDocument?.error;

// ✅ Combined State
export const selectSupportedDocumentsState = (state) => state?.supportedDocuments;